import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import Select from 'react-select'
import { useForm } from 'react-hook-form'
import axios from 'axios'

const initialState = {
  name: '',
  email: '',
}

function ViewStudent({ onClose, studentId }) {
  const [student, setStudent] = useState(null)
  useEffect(() => {
    if (studentId) {
      getSingleUser(studentId)
    }
  }, [studentId])

  const getSingleUser = async (id) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}edit/${id}`
    )
    if (response.status === 200) {
      setStudent(response.data)
    }
  }

  if (!student) return null

  return (
    <div
      className="content-body container font-sans"
      style={{ padding: 26, borderRadius: 20, background: '#fff' }}
    >
      <h4 className="card-title text-[#030303] font-bold text-xl pb-6">
        View Student
      </h4>
      <div className="grid grid-cols-2 gap-x-6 gap-y-4 pt-2">
        <div>
          <label className="block text-[#535862] font-medium mb-1">
            First Name
          </label>
          <div className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px]">
            {student.first_name}
          </div>
        </div>
        <div>
          <label className="block text-[#535862] font-medium mb-1">
            Middle Name
          </label>
          <div className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px]">
            {student.middle_name}
          </div>
        </div>
        <div>
          <label className="block text-[#535862] font-medium mb-1">
            Last Name
          </label>
          <div className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px]">
            {student.last_name}
          </div>
        </div>
        <div>
          <label className="block text-[#535862] font-medium mb-1">
            Email Address
          </label>
          <div className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px]">
            {student.email}
          </div>
        </div>
        <div>
          <label className="block text-[#535862] font-medium mb-1">
            School
          </label>
          <div className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px]">
            {student.school}
          </div>
        </div>
        <div>
          <label className="block text-[#535862] font-medium mb-1">
            Unweighted GPA
          </label>
          <div className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px]">
            {student.gpa}
          </div>
        </div>
        <div>
          <label className="block text-[#535862] font-medium mb-1">Phone</label>
          <div className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px]">
            {student.phone}
          </div>
        </div>
        <div className="col-span-2">
          <label className="block text-[#535862] font-medium mb-1">
            Additional Notes
          </label>
          <div className="w-full px-4 py-2 text-[#535862] bg-[#FAFAFA] border border-[#F0F0F0] rounded-[10px] min-h-[80px]">
            {student.notes}
          </div>
        </div>
      </div>
      <div className="flex justify-start gap-3 mt-8">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 rounded-md border border-[#F0F0F0] text-[#535862] bg-white hover:bg-neutral-50 transition-colors font-medium"
        >
          Close
        </button>
      </div>
    </div>
  )
}

export default ViewStudent
